import { Col, Row } from "antd";
import React, { Fragment } from "react";
import NoData from "../../../common/cards/noData";
import InviteCard from "./Card/InviteCard";
const InviteMembers = ({ data, current }) => {
  return (
    <Fragment>
      <Row>
        {data?.members?.length > 1 ? (
          data?.members?.map(
            (e, i) =>
              e.active === false &&
              e.type?.toLowerCase() === "add" && (
                <Col key={i} xxl={6} xl={8} lg={{ span: 12 }} md={{ span: 12 }} sm={24} xs={24}>
                  <InviteCard data={e} current={current} />
                </Col>
              )
          )
        ) : (
          <Col
            span={24}
            style={{
              display: "flex",
              alignItems: "stretch"
            }}>
            <NoData noMembers />
          </Col>
        )}
      </Row>
    </Fragment>
  );
};

export default InviteMembers;
